import logo from './logo.svg';
import './App.css';
import Header from "./components/Header";

function App() {
  return (
      <div>
        <Header />
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>Hello teams of Levan</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
      <div>

      </div>
      </div>
  );
}

export default App;
